var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedshift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1615 1783.7",
    viewBox: "0 0 1615 1783.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m807.5 1363.8 678.3 161.5v-1270.5l-678.3 161.5z",
    fill: "#205b97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1485.8 254.8 129.2 64.6v1141.3l-129.2 64.6zm-678.3 1109-678.3 161.5v-1270.5l678.3 161.5z",
    fill: "#5193ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m129.2 254.8-129.2 64.6v1141.3l129.2 64.6z",
    fill: "#205b97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m979.8 1783.7 258.4-129.2v-1525.3l-258.4-129.2-79 847z",
    fill: "#5193ce"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m635.2 1783.7-258.4-129.2v-1525.3l258.4-129.2 79 847z",
    fill: "#205b97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m635.2 0h348.1v1780.1h-348.1z",
    fill: "#2e73b7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedshift);
export default __webpack_public_path__ + "static/media/redshift.af1e514f07ad71e72a51a609b3c79e84.svg";
export { ForwardRef as ReactComponent };